import React from "react";
import "./NetworkErrorMsg.css";

const NetworkErrorMsg = () => {
  return (
    <div className="networkErrMessagePopUpOuterContainer">
      <div className="networkErrMessagePopUpContainer">
        <div className="networkErrMessagePopUpContents">
          <div className="networkErrMessagePopUpContentsDecorator">&nbsp;</div>
          <p className="networkErrMessagePopUpContentsText">
            Your browser disconnected you from the server for being idle. Click
            refresh to rejoin the room.
            <br></br>
            <div className="networkErrButtonContainer">
              <div
                className="networkErrButtonLeave"
                onClick={() => {
                  window.location.href = `/`;
                }}
              >
                Leave
              </div>
              <div
                className="networkErrButtonRefresh"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Refresh
              </div>
            </div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NetworkErrorMsg;
